import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2xs10,
    GridItem3,
    GridItem3xs10,
    GridItem6,
    GridItem6xs10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    UploadFileUploadArquivos,
    VisualizarArquivo,
    ExclusaoArquivo,
 } from '../acompanhamento-form/AcompanhamentoCompArquivo'

import {
    TablePaginationPadraoSolicitacaoArquivo,
    rowPertentePageSolicitacaoArquivo,
    setPageInclusaoSolicitacaoArquivo,
    TipoSolicitacaoArquivo,
    ObservacaoSolicitacaoArquivo,
    IconButtonClearEntradaDadosSolicitacaoArquivo,
} from './FormCompSolicitacaoArquivo'

import {
    incrementaContSolicitacaoArquivo,
    processaRegistrosDefaultIniciaisSolicitacaoArquivo,
    processaValoresDefaultIniciaisSolicitacaoArquivo,
} from './FormServiceSolicitacaoArquivo'



const FormFormSolicitacaoArquivo = ({ variaveisGlobais, values, handleChange, setFieldValue, vars,
    arquivoList, obterArquivoList/*, jsonConfiguracao, title*/ }) => {

    processaRegistrosDefaultIniciaisSolicitacaoArquivo(values/*, jsonConfiguracao*/)

    //calculaTotaisEducacao(values)

    useSingleton(async () => {

        values.pageSolicitacaoArquivo = obtemPage(values.pageSolicitacaoArquivoList, HARDCODE.idFamiliarPage)
    })

    salvaPage(values.pageSolicitacaoArquivo, values.pageSolicitacaoArquivoList, HARDCODE.idFamiliarPage)

    values.solicitacaoArquivoPagination = values.solicitacaoArquivo

    const isXsDownScreen = IsXsDownScreen()


    
    return (
        <FieldArray name="solicitacaoArquivo">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.solicitacaoArquivo?.map((item, ind) => {

                            if (rowPertentePageSolicitacaoArquivo(values, ind)) {

                                processaValoresDefaultIniciaisSolicitacaoArquivo(item)

                                const arquivoListSolicitacaoArquivo =
                                    arquivoList.filter( linhaArquivoList =>
                                        linhaArquivoList.idTipoSolicitacaoArquivo ===
                                            item.id)

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem3xs10>
                                                <TipoSolicitacaoArquivo
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                    disabled={arquivoListSolicitacaoArquivo.length > 0 ||
                                                        values.jsonAcessoCliente.acessoCliente
                                                    }
                                                />
                                            </GridItem3xs10>

                                            <GridItem6xs10>
                                                <ObservacaoSolicitacaoArquivo
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                    disabled={values.jsonAcessoCliente.acessoCliente}
                                                />
                                            </GridItem6xs10>

                                            <GridItem2xs10
                                                className="mt-2"
                                                align='center'
                                            >
                                                {item.tipoSolicitacaoArquivo && (
                                                    <UploadFileUploadArquivos
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        vars={vars}
                                                        obterArquivoList={obterArquivoList}
                                                        idTipoSolicitacaoArquivo={item.id}
                                                        tipoSolicitacaoArquivo={item.tipoSolicitacaoArquivo}
                                                    />
                                                )}
                                            </GridItem2xs10>

                                            <GridItem1xs2>
                                                <GridContainer>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                    </GridItem6>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <IconButtonClearEntradaDadosSolicitacaoArquivo
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            ind={ind}
                                                            arrayHelpers={arrayHelpers}
                                                            arquivoListSolicitacaoArquivo={
                                                                arquivoListSolicitacaoArquivo
                                                            }
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem1xs2>
                                        </GridContainer>

                                        {arquivoListSolicitacaoArquivo?.map((item2, ind2) => {

                                            return (
                                                <GridContainer
                                                    className='mt-2 mb-2'
                                                >
                                                    {!isXsDownScreen && (
                                                        <GridItem3/>
                                                    )}

                                                    <GridItem6xs10>
                                                        <div
                                                            className='text-black ml-4'
                                                        >
                                                            {item2.nomeArquivo}
                                                        </div>
                                                    </GridItem6xs10>

                                                    <GridItem2xs10>
                                                        <div
                                                            className={
                                                                item2?.extensaoArquivo === HARDCODE.PDF
                                                                    ?
                                                                        'ml--5'
                                                                    :
                                                                        'ml--7'
                                                            }
                                                        >
                                                            <VisualizarArquivo
                                                                variaveisGlobais={variaveisGlobais}
                                                                arquivoCliente={item2}
                                                            />
                                                        </div>
                                                    </GridItem2xs10>

                                                    <GridItem1xs2>
                                                        <ExclusaoArquivo
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            arquivoCliente={item2}
                                                            obterArquivoList={obterArquivoList}
                                                        />
                                                    </GridItem1xs2>
                                                </GridContainer>
                                            )
                                        })}
                                        
                                        {isXsDownScreen && values.solicitacaoArquivoPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoSolicitacaoArquivo
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    {!values.jsonAcessoCliente.acessoCliente && (
                        <GridContainerGridItemButtonIncluirLinha>
                            <ButtonIncluirLinha
                                label={LABEL.buttonIncluirSolicitacaoArquivo} 
                                align='right'
                                //disabled={familiaresList(values).length === 0 ? true : false}
                                onClick={() => 
                                    {
                                        incrementaContSolicitacaoArquivo(values)
                                        arrayHelpers.push({
                                            id: values.contSolicitacaoArquivo,
                                        })
                                        setPageInclusaoSolicitacaoArquivo(values, setFieldValue)
                                    }
                                }
                            />
                        </GridContainerGridItemButtonIncluirLinha>
                    )}
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormSolicitacaoArquivo